import { useEffect, useState } from "react";
import { API_URL } from "../constant";

const TIER_COLORS = {
  5: "#cd7f32",
  10: "#C0C0C0",
  25: "#FFD700",
};

export function formatGbp(value) {
  const num = Number(value);
  if (Number.isInteger(num)) {
    return `£${num}`;
  }
  return `£${num.toFixed(2)}`;
}

export const DEFAULT_CAPTAIN_TC_CARDS = [
  {
    tier: 5,
    title: "£5 Card",
    amount_label: "£5",
    eligible_reward: 2.5,
    eligible_label: "£2.50",
    purchase_topcoin: 5,
    color: TIER_COLORS[5],
  },
  {
    tier: 10,
    title: "£10 Card",
    amount_label: "£10",
    eligible_reward: 5,
    eligible_label: "£5",
    purchase_topcoin: 10,
    color: TIER_COLORS[10],
  },
  {
    tier: 25,
    title: "£25 Card",
    amount_label: "£25",
    eligible_reward: 12.5,
    eligible_label: "£12.50",
    purchase_topcoin: 25,
    color: TIER_COLORS[25],
  },
];

function normalizeCard(card) {
  const tier = Number(card.tier);
  const eligibleReward = Number(card.eligible_reward);

  return {
    tier,
    title: card.title || `${formatGbp(tier)} Card`,
    amount_label: card.amount_label || formatGbp(tier),
    eligible_reward: eligibleReward,
    eligible_label: formatGbp(eligibleReward),
    purchase_topcoin: Number(card.purchase_topcoin ?? tier),
    color: TIER_COLORS[tier] || "#FFD700",
  };
}

export function useCaptainTcCardConfig() {
  const [cards, setCards] = useState(DEFAULT_CAPTAIN_TC_CARDS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function fetchConfig() {
      try {
        const response = await fetch(`${API_URL}/api/config/captain-tc-cards`, {
          headers: { Accept: "application/json" },
        });

        if (!response.ok) {
          return;
        }

        const data = await response.json();
        if (!cancelled && data.success && Array.isArray(data.cards) && data.cards.length) {
          setCards(data.cards.map(normalizeCard));
        }
      } catch (error) {
        console.warn("Captain TC card config unavailable:", error.message);
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    fetchConfig();

    return () => {
      cancelled = true;
    };
  }, []);

  return { cards, loading };
}
